import { createStore } from 'vuex'
import axios from 'axios'
import * as Config from "../config";
import Cookies from "js-cookie";
import country from './modules/country'
import user from './modules/user'
import serie from './modules/serie'
import router from '../routes/routes';
import moment from 'moment';

axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("access_token");

export default createStore({
  state: {

  },
  actions: {
    // Inicio Peticiones de auth
    login({ commit }, form) {
      //commit("LOGIN");

      return new Promise((resolve, reject) => {
        axios
          .post(Config.apiPath + "/auth/login_user", form)
          .then(response => {
            if (response.data.code === 200) {
              const accessToken = response.data.data.access_token.token;
              const expires_in = moment().format("YYYY-MM-DD HH:mm");
              const expires_at = moment(expires_in).add(48, 'hours').format("YYYY-MM-DD HH:mm");
              const expires_at_date = new Date(expires_at);

              
              const id = response.data.data.id;
              const id_type_user = response.data.data.id_type_user;
              
              Cookies.set("access_token", accessToken, { expires: expires_at_date });
              Cookies.set("id", id, { expires: expires_at_date })
              Cookies.set("id_type_user", id_type_user, { expires: expires_at_date })

              resolve(response.data);
            } else {
              commit("LOGIN_FAIL1");
              reject(response.data);
            }
          })
          .catch(error => {
            // console.log("LOGIN_FAIL");
            // console.log(error);
            reject(error);
          });
      });
    },

    clubLogin({ commit }, form) {
      //commit("LOGIN");

      return new Promise((resolve, reject) => {
        axios
          .post(Config.apiPath + "/auth/login", form)
          .then(response => {
            if (response.data.code === 200) {
              console.log(response.data.data) 
              const accessToken = response.data.data.access_token.token;
              const expires_in = moment().format("YYYY-MM-DD HH:mm");
              const expires_at = moment(expires_in).add(48, 'hours').format("YYYY-MM-DD HH:mm");
              const expires_at_date = new Date(expires_at);
              
              console.log(accessToken)
              /* onst username = response.data.data.full_name;
             const useremail = response.data.data.email;
             const profile = response.data.data.profile_picture;
             const id_role = response.data.data.role; */
              // const id_role = response.data.data.id_role;
              const id = response.data.data.id;
              const id_club = response.data.data.id_club;
              Cookies.set("access_token", accessToken, { expires: expires_at_date });
              /*  Cookies.set("user_name", username)
              Cookies.set("user_email", useremail)
              Cookies.set("picture", profile)
              Cookies.set("id_role", id_role) */
              Cookies.set("id", id, { expires: expires_at_date })
              Cookies.set("id_club", id_club, { expires: expires_at_date })
              // Cookies.set("id_role", id_role)
              //commit("LOGIN", response.data);
              resolve(response.data);
              
            } else {
              commit("LOGIN_FAIL1");
              reject(response.data);
            }
          })
          .catch(error => {
            // console.log("LOGIN_FAIL");
            // console.log(error);
            reject(error);
          });
      });
    },
    
    adminLogin({ commit }, form) {
      return new Promise((resolve, reject) => {
        axios
          .post(Config.apiPath + "/admin/auth/login", form)
          .then(response => {
            if (response.data.code === 200) {
              const accessToken = response.data.data.access_token.token;
              const id = response.data.data.id;
              const role = response.data.data.id_rol;
              const expires_in = moment().format("YYYY-MM-DD HH:mm");
              const expires_at = moment(expires_in).add(48, 'hours').format("YYYY-MM-DD HH:mm");
              const expires_at_date = new Date(expires_at);

              Cookies.set("access_token", accessToken, { expires: expires_at_date });
              Cookies.set("id", id, { expires: expires_at_date })
              Cookies.set("role", role, { expires: expires_at_date })
              resolve(response.data);
            } else {
              commit("LOGIN_FAIL1");
              reject(response.data);
            }
          })
          .catch(error => { reject(error); });
      });
    },
    
    logout() {
      // Cookies.remove("access_token");
      // Cookies.remove("id");
      // Cookies.remove("id_club")
      const cookies = Cookies.get();
      for (const cookie in cookies) {
        Cookies.remove(cookie);
      }
    },

    login_rne({ commit }, form) {
      return new Promise((resolve, reject) => {
        axios
          .post(Config.apiPath + "/auth/login_rne", form)
          .then(response => {
            if (response.data.code === 200) {
              // Si el usuario ya completó su perfil en CCD (is_rne = 1), guardar cookies como login normal
              if (response.data.data.is_rne === 1) {
                const accessToken = response.data.data.access_token.token;
                const expires_in = moment().format("YYYY-MM-DD HH:mm");
                const expires_at = moment(expires_in).add(48, 'hours').format("YYYY-MM-DD HH:mm");
                const expires_at_date = new Date(expires_at);

                const id = response.data.data.id;
                const id_type_user = response.data.data.id_type_user;

                Cookies.set("access_token", accessToken, { expires: expires_at_date });
                Cookies.set("id", id, { expires: expires_at_date });
                Cookies.set("id_type_user", id_type_user, { expires: expires_at_date });
              }
              resolve(response.data);
            } else {
              reject(response.data);
            }
          })
          .catch(error => {
            reject(error.response ? error.response.data : error);
          });
      });
    },

    // DEFINITIONS

    getData({ commit, dispatch },form) {
      // console.log(dispatch)
      // console.log(commit)
      return new Promise((resolve, reject) => {
        axios.get(Config.apiPath +"/"+ form.url,{params:form.params},{headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Cookies.get('access_token')}`
      }})
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },

    getRegisterData({ commit, dispatch },form) {
      // console.log(dispatch)
      // console.log(commit)
      return new Promise((resolve, reject) => {
        axios.get(Config.apiPath +"/"+ form.url,{params:form.params})
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },

    getDataLite({ commit, dispatch },form) {
      // console.log(dispatch)
      // console.log(commit)
      return new Promise((resolve, reject) => {
        axios.get(Config.apiPath +"/"+ form.url,{headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Cookies.get('access_token')}`
      }})
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },

    createData({ commit, dispatch }, form) {
      // console.log(dispatch)
      // console.log(commit)
      // console.log(form.data)
      return new Promise((resolve, reject) => {
        axios.post(Config.apiPath +"/"+ form.url, form.data,{headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Cookies.get('access_token')}`
      }})
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    
    recoverData({ commit, dispatch }, form) {
      // console.log(dispatch)
      // console.log(commit)
      // console.log(form.data)
      return new Promise((resolve, reject) => {
        axios.post(Config.apiPath +"/"+ form.url, form.data)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },

    recoverPassword({ commit, dispatch }, form) {
      // console.log(dispatch)
      // console.log(commit)
      // console.log(form.data)
      return new Promise((resolve, reject) => {
        axios.put(Config.apiPath +"/"+ form.url, form.data)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },

    updateData({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios.put(Config.apiPath +"/"+ form.url+'/' + form.id, form.data,{headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Cookies.get('access_token')}`
      }})
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    updateDataAutenticated({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios.put(Config.apiPath +"/"+ form.url, form.data,{headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Cookies.get('access_token')}`
      }})
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    updateDataClean({ commit, dispatch }, form) {
      // console.log(dispatch)
      // console.log(commit)
      return new Promise((resolve, reject) => {
        axios.put(Config.apiPath +"/"+ form.url, form.data,{headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Cookies.get('access_token')}`
      }})
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },

    changeStatusData({ commit, dispatch }, form) {
      // console.log(dispatch)
      // console.log(commit)
      return new Promise((resolve, reject) => {
        axios.put(Config.apiPath +"/"+ form.url+"/"+ form.id + "/" + form.status,{headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Cookies.get('access_token')}`
      }})
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },

    

    getFile({ commit, dispatch }, form) {
      // console.log(dispatch)
      // console.log(commit)
      return new Promise((resolve, reject) => {
        axios.get(Config.apiPath + "/upload/all?active=1&type=" + form.type + "&page=" + form.page,{headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Cookies.get('access_token')}`
      }})
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    getFileMemeRequests({ commit, dispatch }) {
      // console.log(dispatch)
      // console.log(commit)
      return new Promise((resolve, reject) => {
        axios.get(Config.apiPath + "/upload/meme/all",{headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Cookies.get('access_token')}`
      }})
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },

    UserCreateDT({ commit, dispatch }, form) {
      const client_id = 'Vinotinto';
      const secret = 'Corazon123';
      const base64 = window.btoa(client_id + ':' + secret);

      const userId = form.data.user_id;
      const secret_key = 'FVF_Key';

      const encoder = new TextEncoder();
      const data = encoder.encode(userId);

      const cryptoKeyPromise = crypto.subtle.importKey(
        'raw',
        encoder.encode(secret_key),
        { name: 'HMAC', hash: 'SHA-256' },
        false,
        ['sign']
      );
      return cryptoKeyPromise.then(cryptoKey => {
        return crypto.subtle.sign('HMAC', cryptoKey, data)
          .then(signature => {
            const signatureHex = Array.from(new Uint8Array(signature))
              .map(byte => byte.toString(16).padStart(2, '0'))
              .join('');
            console.log('Base64:', base64);
            console.log('HMAC', signatureHex);
            const instance = axios.create({
              baseURL: 'https://api-lpdt.herokuapp.com',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Basic ${base64}`,
                'X-Signature': signatureHex
              }
            });

            return instance.post("/webhooks/create_user_fvf", form)
              .then(response => {
                console.log(response);
                return response.data;
              })
              .catch(error => {
                console.log(error);
                throw error.response.data;
              });
          });
      });
    },

    UploadFile({ commit, dispatch }, form) {
      // console.log(dispatch)
      // console.log(commit)
      return new Promise((resolve, reject) => {
        axios.post(Config.apiPath + "/upload/file", form,{headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Cookies.get('access_token')}`
      }})
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },

    FileStatus({ commit, dispatch }, form) {
      // console.log(dispatch)
      // console.log(commit)
      return new Promise((resolve, reject) => {
        axios.put(Config.apiPath + "/upload/change_status/" + form.id + "/" + form.status,{headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Cookies.get('access_token')}`
      }})
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },

    getVideo({ commit, dispatch }) {
      // console.log(dispatch)
      // console.log(commit)
      return new Promise((resolve, reject) => {
        axios.get(Config.apiPath + "/upload/all?active=1",{headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Cookies.get('access_token')}`
      }})
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },

    UploadVideo({ commit, dispatch }, form) {
      // console.log(dispatch)
      // console.log(commit)
      return new Promise((resolve, reject) => {
        axios.post('https://apibit.ticktaps.xyz/api/1.0/upload/file', form,{headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Cookies.get('access_token')}`
      }})
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            resolve(error.response.data);
            reject(error.response.data);
          });
      });
    },
  },
  mutations: {
    
  },
  modules: {
    country,
    user,
    serie,
}
})